import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORIES = [
  { slug: "way-of-life", label: "Way of Life", color: "#FFD01E", textColor: "#050505" },
  { slug: "sexploration", label: "Sexploration", color: "#FA6157", textColor: "#050505" },
  { slug: "chut-on-teste", label: "Chut ! On Teste", color: "#D9C5FD", textColor: "#050505" },
  { slug: "intimite-masculine", label: "Intimité Masculine", color: "#0A8074", textColor: "#FFFDF7" },
  { slug: "podcast", label: "Podcast", color: "#050505", textColor: "#FFD01E" },
];

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);

/** Resolve cover image URL: relative /api/... paths get prefixed with backend URL. */
export const imgSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
